import { useContext } from 'react';

import { WebViewContext } from '@myrealtrip/device-detect';

import useFetchUserInfo from './apis/useFetchUserInfo';

function useUserInfo() {
  const { isWebView } = useContext(WebViewContext);

  const { data, isError, isLoading } = useFetchUserInfo(isWebView);

  return {
    isLoading,
    userId: Number(data?.id),
    accessToken: data?.accessToken,
    hasError: isError,
  };
}

export default useUserInfo;
